Ext.define('SA.FilterExpressions', {
    singleton: true,

    toFilter(filter) {
        var [operator, ...expressions] = filter,
            predicates = expressions.map(expression => {
                var [operator, ...tail] = expression;

                if (operator === 'and') {
                    let [[op1, attribute1, min], [op2, attribute2, max]] = tail;

                    return SA.FilterPredicate.between(attribute1, min, max);
                }
                else {
                    let [attribute, comparand] = tail;

                    if (operator === '=') {
                        return SA.FilterPredicate.equal(attribute, comparand);
                    }
                    else if (operator === '>') {
                        return SA.FilterPredicate.greaterThan(attribute, comparand);
                    }
                    else if (operator === '>=') {
                        return SA.FilterPredicate.greaterThanOrEqual(attribute, comparand);
                    }
                    else if (operator === '<') {
                        return SA.FilterPredicate.lessThan(attribute, comparand);
                    }
                    else if (operator === '<=') {
                        return SA.FilterPredicate.lessThanOrEqual(attribute, comparand);
                    }
                    else if (operator === '<>') {
                        return SA.FilterPredicate.notEqual(attribute, comparand);
                    }
                }
            });

        if (operator === 'and') {
            return SA.Filter.and(...predicates);
        }
        else if (operator === 'or') {
            return SA.Filter.or(...predicates);
        }
    }
});